export default __webpack_public_path__ + "static/media/20_header_order.e7dcf160.png";